import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TravelLineTicket } from '../models/travel-line-ticket';

@Injectable({
  providedIn: 'root'
})
export class SapService {
  constructor(private http:HttpClient) { }

  getTickets(ticket, society) : Promise<TravelLineTicket[]> {
    return this.http.get<TravelLineTicket[]>('/api/sap/ticket', {params: {'ticket': ticket, 'society': society}}).toPromise();
  }
}
